import { Step } from 'react-joyride';

export const steps = [
  {
    target: '#dashboard-1',
    content: "Below, you'll find the latest statistics pertaining to your application.",
    disableBeacon: true,
    hideCloseButton: true,
    placement: 'top',
    showSkipButton: true,
  },
  {
    target: '#dashboard-2',
    content: 'The graph illustrates the frequency of API usage.',
    disableBeacon: true,
    hideCloseButton: true,
    showSkipButton: true,
  },
  {
    target: '#dashboard-3',
    content: 'Here you will see the current application or you can switch to another.',
    disableBeacon: true,
    hideCloseButton: true,
    showSkipButton: true,
  },
  {
    target: '#dashboard-4',
    content: 'In the navigation bar, you can view the details of your application.',
    disableBeacon: true,
    hideCloseButton: true,
    showSkipButton: true,
  },
  {
    target: '#dashboard-5',
    content: 'Here you can view the current plan, change the settings, or invite to the team.',
    disableBeacon: true,
    hideCloseButton: true,
    showSkipButton: true,
  },
] as Array<Step>;

export const locale = {
  last: 'Done',
};
